/* src/app/modules/expense/salary/salary.component.css */
.readonly-wrapper .readonly-block {
  pointer-events: none;
}
:host ::ng-deep .sl-field-full {
  width: 100% !important;
}
.sl-form {
  padding-bottom: 2rem;
}
.tf-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0 1.25rem;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 1.5rem;
}
.tf-page-title {
  font-weight: 700;
  font-size: 1.4rem;
  color: #1f2937;
  margin: 0;
}
.tf-card mat-card-content {
  padding: 1.25rem !important;
}
.tf-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.tf-section-title {
  font-weight: 600;
  font-size: 1rem;
  color: #1f2937;
  margin: 0;
}
.sv-field-help {
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
}
.sv-field-help mat-form-field {
  flex: 1;
  min-width: 0;
}
.sv-field-help app-help {
  flex-shrink: 0;
  margin-top: 0.8rem;
}
.sl-euro-suffix {
  font-size: 14px;
  color: #9ca3af;
  font-weight: 500;
  margin-right: 6px;
}
.sl-spin-icon {
  font-size: 17px;
  color: #9ca3af;
}
.pf-section-divider {
  border-top: 1px solid #f0f0f0;
  margin-bottom: 0.75rem;
}
.pf-totals-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.sl-net-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1f2937;
}
.sl-net-field {
  display: flex;
  align-items: flex-start;
}
.sl-net-input {
  width: 220px;
  font-weight: 700;
  font-size: 1.1rem;
}
/*# sourceMappingURL=salary.component.css.map */
